// src/Component/former/Former.js
import React from 'react';
import { Helmet } from 'react-helmet'; // <-- Import Helmet
import './cylinder.css';
import cyl1 from '../../image/cyl1.png';

const Cylinder = () => {
  return (
    <div className="details-container">

      {/* SEO Meta Tags */}
      <Helmet>
        <title>Cylinder Mould Paper Machine Manufacturers in India</title>
        <meta
          name="description"
          content="Cylinder Mould Paper Machine Manufacturers in India. P. Rakesh Industries is a leading manufacturer of cylinder moulds for paper and board machines in India. Our stainless steel cylinder moulds ensure precision, durability, and high-speed performance for kraft paper, duplex board, and coated board production with superior dewatering and long wire life."
        />
        <meta property="og:title" content="Cylinder Mould Paper Machine Manufacturers in India" />
        <meta
          property="og:description"
          content="Cylinder Mould Paper Machine Manufacturers in India. P. Rakesh Industries is a leading manufacturer of cylinder moulds for paper and board machines in India. Our stainless steel cylinder moulds ensure precision, durability, and high-speed performance for kraft paper, duplex board, and coated board production with superior dewatering and long wire life."
        />
                <meta property="og:url" content="https://pripapermachines.com/cylinder-mould-paper-machine-manufacturers-in-india" />
        <link rel="canonical" href="https://pripapermachines.com/cylinder-mould-paper-machine-manufacturers-in-india" />
      </Helmet>

      <div className="details-content">
        {/* Left Column */}
        <div className="column left">
          <h1 style={{color:"#4d7544"}} className='mobileresponsiveview'>CYLINDER MOULD</h1>
          <div>
            <img src={cyl1} alt="Cylinder Mould" />
          </div>
        </div>

        {/* Right Column */}
        <div className="column right">
          <div className="column-right">
            <h1 style={{ color: "#4d7544", marginTop: "-10px", textAlign: "left", fontSize: "40px" }} className='desktopresponsiveview'>CYLINDER MOULD</h1>

            <div>
              <p
                style={{
                  backgroundColor: "#4d7544",
                  borderRadius: "10px",
                  color: "white",
                  paddingLeft: "20px",
                  paddingBottom: "20px",
                  paddingRight: "20px",
                  paddingTop: "20px",
                  width: "100%",
                  boxSizing: "border-box",
                  textAlign: "left"
                }}
              >
                <ul>
                  <li>The cylinder mould is important equipment for producing multilayer paper on board. The PRI cylinder mould is designed for sturdy construction, corrosion resistance, and precise tolerance of machining. Due to its robust build quality, the PRI cylinder mould is suitable for running in Pressure Formers, Restricted flow vats, or dry vats.</li>
                  <br />
                  <li>All necessary care is taken in designing and manufacturing the cylinder mould which allows it to run at high speed with a sufficient nip load and proper dewatering. The outside diameter of the cylinder mould is machined to high accuracy for producing good-quality boards. PRI cylinder moulds are normally manufactured with S.S. 304 material; in special cases, cylinder moulds are offered in S.S. 316L material to avoid environmental effects. Selection of raw materials results in trouble-free operation over years.</li>
                  <br />
                  <li>We can offer a higher-diameter cylinder mould for a higher-speed machine.</li>
                </ul>
              </p>

              <h1 style={{ color: "#4d7544", textAlign: "left", fontSize: "26px", marginTop: "20px" }}>Key Features:</h1>
              <ul style={{ color: "black", textAlign: "left", marginBottom: "60px" }}>
                <li>High drawing capacity</li>
                <br />
                <li>Near-perfect concentricity</li>
                <br />
                <li>Maximum open area for dewatering</li>
                <br />
                <li>Minimum deflection due to a design that emphasizes stiffness and rigidity</li>
                <br />
                <li>Long wire life due to its highly finished outside diameter</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Cylinder;
